import { Component, ReactNode } from 'react';
import { ErrorRecovery } from './ErrorRecovery';
import { errorTracker } from '@/utils/errorTracking';

interface Props {
  children: ReactNode;
  fallback?: (error: Error, reset: () => void) => ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundaryWithRecovery extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    errorTracker.logError(error, 'error', {
      componentStack: errorInfo.componentStack,
      boundary: 'ErrorBoundaryWithRecovery',
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError && this.state.error) {
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, this.handleReset);
      }

      return (
        <div className="flex items-center justify-center min-h-[400px] p-4">
          <div className="max-w-lg w-full">
            <ErrorRecovery error={this.state.error} onRetry={this.handleReset} />
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
